import type { SVGProps } from "react";
import * as React from "react";

const SvgBold = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 4V3a1 1 0 0 0-1 1zm8 0V3zm0 8v1zm1 0v-1zm-9 8H5a1 1 0 0 0 1 1zM6 5h8V3H6zm8 0a3 3 0 0 1 2.121.879l1.415-1.415A5 5 0 0 0 14 3zm2.121.879A3 3 0 0 1 17 8h2a5 5 0 0 0-1.465-3.536zM17 8a3 3 0 0 1-.879 2.121l1.415 1.415A5 5 0 0 0 19 8zm-.879 2.121A3 3 0 0 1 14 11v2a5 5 0 0 0 3.535-1.464zM14 11H6v2h8zm-7 1V4H5v8zm-1 1h9v-2H6zm9 0a3 3 0 0 1 2.121.879l1.415-1.415A5 5 0 0 0 15 11zm2.121.879A3 3 0 0 1 18 16h2a5 5 0 0 0-1.465-3.536zM18 16a3 3 0 0 1-.879 2.121l1.415 1.415A5 5 0 0 0 20 16zm-.879 2.121A3 3 0 0 1 15 19v2a5 5 0 0 0 3.535-1.465zM15 19H6v2h9zm-8 1v-8H5v8z"
    />
  </svg>
);
export default SvgBold;
